import * as i from "react";
import { createContextScope as w } from "../../../../../@radix-ui_react-context@1.1.3_@types_react@19.2.14_react@19.2.4/bundled_deps/@radix-ui/react-context/dist/index.js";
import { useCallbackRef as C } from "../../../../../@radix-ui_react-use-callback-ref@1.1.1_@types_react@19.2.14_react@19.2.4/bundled_deps/@radix-ui/react-use-callback-ref/dist/index.js";
import { useLayoutEffect as f } from "../../../../../@radix-ui_react-use-layout-effect@1.1.1_@types_react@19.2.14_react@19.2.4/bundled_deps/@radix-ui/react-use-layout-effect/dist/index.js";
import { Primitive as m } from "../../../../../@radix-ui_react-primitive@2.1.4_@types_react-dom@19.2.3_@types_react@19.2.14__@types_re_0243fb2db8a1fb85ca77b8d9e5c2d650/bundled_deps/@radix-ui/react-primitive/dist/index.js";
import { useIsHydrated as h } from "../../../../../@radix-ui_react-use-is-hydrated@0.1.0_@types_react@19.2.14_react@19.2.4/bundled_deps/@radix-ui/react-use-is-hydrated/dist/index.js";
import { j as l } from "../../../../../../../_virtual/jsx-runtime.js";
var v = "Avatar", [_] = w(v), [y, A] = _(v), L = i.forwardRef(
  (a, e) => {
    const { __scopeAvatar: o, ...r } = a, [n, t] = i.useState("idle");
    return /* @__PURE__ */ l.jsx(
      y,
      {
        scope: o,
        imageLoadingStatus: n,
        onImageLoadingStatusChange: t,
        children: /* @__PURE__ */ l.jsx(m.span, { ...r, ref: e })
      }
    );
  }
);
L.displayName = v;
var S = "AvatarImage", E = i.forwardRef(
  (a, e) => {
    const { __scopeAvatar: o, src: r, onLoadingStatusChange: n = () => {
    }, ...t } = a, u = A(S, o), s = j(r, t), d = C((c) => {
      n(c), u.onImageLoadingStatusChange(c);
    });
    return f(() => {
      s !== "idle" && d(s);
    }, [s, d]), s === "loaded" ? /* @__PURE__ */ l.jsx(m.img, { ...t, ref: e, src: r }) : null;
  }
);
E.displayName = S;
var x = "AvatarFallback", R = i.forwardRef(
  (a, e) => {
    const { __scopeAvatar: o, delayMs: r, ...n } = a, t = A(x, o), [u, s] = i.useState(r === void 0);
    return i.useEffect(() => {
      if (r !== void 0) {
        const d = window.setTimeout(() => s(!0), r);
        return () => window.clearTimeout(d);
      }
    }, [r]), u && t.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ l.jsx(m.span, { ...n, ref: e }) : null;
  }
);
R.displayName = x;
function p(a, e) {
  return a ? e ? (a.src !== e && (a.src = e), a.complete && a.naturalWidth > 0 ? "loaded" : "loading") : "error" : "idle";
}
function j(a, { referrerPolicy: e, crossOrigin: o }) {
  const r = h(), n = i.useRef(null), t = r ? (n.current || (n.current = new window.Image()), n.current) : null, [u, s] = i.useState(
    () => p(t, a)
  );
  return f(() => {
    s(p(t, a));
  }, [t, a]), f(() => {
    const d = (I) => () => {
      s(I);
    };
    if (!t) return;
    const c = d("loaded"), g = d("error");
    return t.addEventListener("load", c), t.addEventListener("error", g), e && (t.referrerPolicy = e), typeof o == "string" && (t.crossOrigin = o), () => {
      t.removeEventListener("load", c), t.removeEventListener("error", g);
    };
  }, [t, o, e]), u;
}
var T = L, H = E, B = R;
export {
  L as Avatar,
  R as AvatarFallback,
  E as AvatarImage,
  B as Fallback,
  H as Image,
  T as Root
};
